import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutDriverFuelCard extends Layout {
    sourceFuelCardDriverList: DataSource;
    tableFuelCards: Table;
}
